const MINUTE_IN_MS = 60 * 1000;

export const getAWSDateTime = (isLocalized, ...dateParams) => {
  const utcDate = new Date(...dateParams);

  return isLocalized
    ? new Date(
        utcDate - utcDate.getTimezoneOffset() * MINUTE_IN_MS
      ).toISOString()
    : utcDate.toISOString();
};
